/**
 * 입력 중 (시안 04 README 5.11, D1a·D1b). 아바타 32 + 말풍선 모양 상자(높이 36, 반경 6 18 18 18) 안 점 3개
 * (6px, 간격 4, 멤버 색, 불투명 1 / .6 / .3 이 1.2초 주기로 돎) + 상자 옆 「{멤버} 입력 중」(12).
 * 한 번에 한 명만. 멤버 말이 오면 같은 자리에서 말풍선으로 바뀝니다(위치 이동 없음).
 * 읽기 도구에는 「{멤버}이 입력 중」을 한 번만 읽힙니다(aria-live polite).
 */
import { withJosa } from '@shared/korean.js';
import { Avatar } from './Avatar.jsx';

const DOT_DELAYS = ['0ms', '400ms', '800ms'];

export function TypingIndicator({ memberKey, name, avatarSize = 32 }) {
    return (
        <div className="flex items-start gap-2">
            <Avatar memberKey={memberKey} size={avatarSize} />
            <div className="flex items-center gap-2">
                <span
                    aria-hidden="true"
                    className="flex h-9 items-center gap-1 rounded-bubble rounded-tl-bubble-tail border border-hairline bg-surface px-3.5"
                >
                    {DOT_DELAYS.map((delay) => (
                        <span
                            key={delay}
                            className="size-1.5 rounded-full motion-safe:animate-typing-dot"
                            style={{ background: `var(--color-m-${memberKey})`, animationDelay: delay }}
                        />
                    ))}
                </span>
                <span role="status" aria-live="polite" className="text-[12px] leading-4 text-text-secondary">
                    <span aria-hidden="true">{name} 입력 중</span>
                    <span className="sr-only">{withJosa(name, '이', '가')} 입력 중</span>
                </span>
            </div>
        </div>
    );
}
